(function ($) {

  const svgTemplate = '<svg class="icon-{iconClass}" focusable="false" aria-hidden="true" aria-label="{label}" role="presentation">' +
  '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + COMMON.Utils.assetBaseURL + '/assets/images/swr/symbols.svg#{iconClass}"></use>' +
  '</svg>';

  /**
   * Utils
   */
  Planet.Util = {};

  Planet.Util.convertISO8601ToDate = function (str) {
    // ignores the milliseconds and the timezone offset
    var matches, date, year;
    if (str === undefined || str === null || str === '') {
      return null;
    }

    matches = str.match(/([\-]{0,1}[0-9]{4})(-([0-9]{2})(-([0-9]{2})(T([0-9]{2})(:([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?)?(Z|(([\-+])([0-9]{2}):([0-9]{2})))?)?)?)?/);

    date = new Date(matches[1], 0, 1);

    if (matches[1]) {
      year = parseInt(matches[1], 10);
      if (0 <= year && year <= 99) {
        date.setUTCFullYear(year);

        // correct off by one error
        if (year !== date.getFullYear()) {
          date.setUTCFullYear(year + (year - date.getFullYear()));
        }
      }
    }

    if (matches[3]) {
      date.setMonth(matches[3] - 1);
    }
    if (matches[5]) {
      date.setDate(matches[5]);
    }
    if (matches[7]) {
      date.setHours(matches[7]);
    }
    if (matches[9]) {
      date.setMinutes(matches[9]);
    }
    if (matches[11]) {
      date.setSeconds(matches[11]);
    }

    return date;
  };

  Planet.Util.dateIsSameDay = function (d1, d2) {
    return (d1.getDate() === d2.getDate()) && (d1.getMonth() === d2.getMonth()) && (d1.getYear() === d2.getYear());
  };

  Planet.Util.dateIsTomorrow = function (date, now) {
    var tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    return Planet.Util.dateIsSameDay(date, tomorrow);
  };

  Planet.Util.dateIsDayAfterTomorrow = function (date, now) {
    var dayAfterTomorrow = new Date(now);
    dayAfterTomorrow.setDate(now.getDate() + 2);
    return Planet.Util.dateIsSameDay(date, dayAfterTomorrow);
  };

  Planet.Util.dateIsInPast = function (date, now) {
    return (date.getTime() < now.getTime());
  };

  Planet.Util.dateIsDayAfterTomorrowOrGreater = function (date, now) {
    var tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    return (date.getDate() > now.getDate()) && (date.getMonth() === now.getMonth()) && (date.getYear() === now.getYear());
  };

  Planet.Util.getNow = function () {
    var url = window.location.href;
    var previewDateRegexp = /_previewDate-(\d*)/;
    var match = url.match(previewDateRegexp);
    var previewDate;
    if (match != null) {
      previewDate = Planet.Util.convertUnixTimeStamp(match[1]);
    }
    return previewDate === undefined ? new Date() : previewDate;
  };

  Planet.Util.convertUnixTimeStamp = function (UNIX_timestamp) {
    var newDate = new Date();
    newDate.setTime(UNIX_timestamp);
    return newDate;
  };

  Planet.Util.getScriptOnce = (function () {
    var urlState = {};

    return function (url, success) {
      if ("undefined" == typeof urlState[url]) {
        init(url, success);
      } else {
        urlState[url](url, success);
      }
    };

    function init(url, success) {
      urlState[url] = loading;
      $.ajax({ // $.getScript has no option to disable CacheBuster
        url: url,
        dataType: "script",
        cache: true,
        success: function () {
          urlState[url] = loaded;
          if (success) {
            success();
          }
        }
      });
    }

    function loading(url, success) {
      // while url is being loaded, do not do anything,
      // success will be called anyway after loading completes
    }

    function loaded(url, success) {
      if (success) {
        success();
      }
    }

  })();

  Planet.Util.addStylesheetOnce = function (href) {
    if ($('link[rel=stylesheet][href="' + href + '"]').length <= 0) {
      $('<link rel="stylesheet" href="' + href + '"/>').appendTo(document.head);
    }
  };

  Planet.Util.loadScript = function (id, src, callback) {
    var js;
    if (document.getElementById(id)) {
      if (typeof callback === 'function') {
        callback()
      }
      return;
    }
    js = document.createElement('script');
    js.id = id;
    js.src = src;
    js.async = false;
    if (typeof callback === 'function') {
      js.onload = callback;
    }
    document.body.appendChild(js);
  };

  Planet.Util.svgIcon = function (iconName, label) {
    label = 'undefined' !== typeof label ? label : '';
    return COMMON.Utils.template(svgTemplate, {
      iconClass: iconName,
      label: label
    })
  };

})(window.jQuery);
